import { effect, Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
    isDarkMode = signal<boolean>(false);

    constructor() {
        const saved = localStorage.getItem('theme');
        if (saved === 'dark') {
            this.isDarkMode.set(true);
            document.documentElement.classList.add('app-dark');
        }
        effect(() => {
            if (this.isDarkMode()) {
                document.documentElement.classList.add('app-dark');
                localStorage.setItem('theme', 'dark');
            } else {
                document.documentElement.classList.remove('app-dark');
                localStorage.setItem('theme', 'light');
            }
        });
    }

    toggle(): void {
        this.isDarkMode.update(v => !v);
    }
}
